export default "__VITE_ASSET__DOvQ0hnJ__"